export default __webpack_public_path__ + "static/media/learning_3.0f373de0.svg";